<template>
  <div class="letter_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t("user.setting") }}
      </div>
    </div>

    <van-cell
      is-link
      @click="$router.push('/language')"
    >
      <template #title>
        <van-icon
          name="list-switching"
          size="14"
          class="menu-icon"
        />
        <span class="custom-title">{{ $t("safe.language") }}</span>
      </template>
    </van-cell>

    <van-cell
      is-link
      @click="$router.push('/setpwd')"
    >
      <template #title>
        <van-icon
          name="lock"
          size="14"
          class="menu-icon"
        />
        <span class="custom-title">{{ $t("safe.signInPassword") }}</span>
      </template>
    </van-cell>

   <!-- <van-cell
      is-link
      @click="$router.push('/setpaypwd')"
    >
      <template #title>
        <van-icon
          name="shield-o"
          size="14"
          class="menu-icon"
        />
        <span class="custom-title">{{ $t("safe.paymentPassword") }}</span>
      </template>
    </van-cell> -->

    <van-cell>
      <template #title>
        <van-icon
          name="brush-o"
          size="14"
          class="menu-icon"
        />
        <span class="custom-title">{{ $t("feng.cache") }}</span>
      </template>
    </van-cell>

    <van-cell value="V1.0.0">
      <template #title>
        <van-icon
          name="info-o"
          size="14"
          class="menu-icon"
        />
        <span class="custom-title">{{ $t("feng.version") }}</span>
      </template>
    </van-cell>

    <div class="logout-wrap">
      <button
        type="button"
        class="history_coupon flex_center basic_btn"
        @click="logout"
      >
        {{ $t("safe.signOut") }}
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Cell, Icon } from "vant";

Vue.use(Cell).use(Icon);

export default {
  name: "Set",
  created() {
    this.$parent.footer("user", false);
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$router.replace("/");
    }
  }
};
</script>

<style lang="less" scoped>
.red_top_bg {
  position: relative;
  top: 0;
  left: 50%;
  z-index: 10;
  transform: translateX(-50%);
}

.menu-icon {
  margin-right: 10px;
}

.custom-title {
  font-size: 12px;
}

.logout-wrap {
  margin: 12px;
}

.letter_wrap {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 12px 18px 78px;
  background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
}

.red_top_bg {
  height: 30px;
  margin-bottom: 12px;
  background: transparent;
}

.red_top_bg .big_tit {
  top: 5px;
  color: #111;
  font-size: 14px;
  line-height: 20px;
}

.red_top_bg .back_left {
  width: 24px;
  height: 24px;
  margin: 3px 0 0;
}

.letter_wrap /deep/ .van-cell {
  min-height: 48px;
  margin-bottom: 8px;
  padding: 14px;
  border-radius: 10px;
  background: #fff;
  color: #111;
  font-size: 12px;
  line-height: 20px;
}

.letter_wrap /deep/ .van-cell::after {
  display: none;
}

.letter_wrap /deep/ .van-cell__value,
.letter_wrap /deep/ .van-cell__right-icon {
  color: #a28fa7;
  font-size: 12px;
}

.menu-icon {
  color: #f8328c;
}

.custom-title {
  font-size: 12px;
}

.logout-wrap {
  margin: 18px 0 0;
}

.history_coupon.basic_btn {
  width: 100%;
  height: 36px;
  border: 0;
  border-radius: 18px;
  background: linear-gradient(100deg, #df4ab7 0%, #6d3bc4 100%) !important;
  color: #fff;
  font-size: 12px;
  line-height: 36px;
}
</style>
